export class NavigationModel {
  pageTitle = '';
  prevTitle = '';
  prevRoute = '';
}
